import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";

import Button from "components/Chakra/Button";
import {
  useModal,
  useCreateModal,
  InitialUseCreateModalType,
} from "../ModalsProvider";

const WatchdogLimitModal: React.FC = () => {
  const { closeModal } = useModal("watchdogLimitModal");

  return (
    <Box textAlign="center">
      <Heading as="h3" mb={5}>
        Přiliš mnoho nabídek
      </Heading>

      <Text>
        Chceme chránit vaši emailovou schránku. Momentálně by vám totiž chodilo
        příliš mnoho upozornění.
        <br />
        <br />
        Zužte prosím výběr na mapě.
      </Text>

      <Button mt={8} onClick={closeModal}>
        Rozumím
      </Button>
    </Box>
  );
};

export const useWatchdogLimitModal: InitialUseCreateModalType = () =>
  useCreateModal("watchdogLimitModal", WatchdogLimitModal, null, null, {
    size: "md",
  });
